import React from 'react';
import { ResponsiveContainer, Tooltip as RechartsTooltip, PieChart, Pie, Cell } from 'recharts';
import PropTypes from 'prop-types';
import Legend from './Legend';
import Tooltip from '../PercentageTooltip';
import { chartColors, calculatePercentages } from '../utils';

const DonutChart = ({
  data,
  height,
  colors,
  hasLegend,
  hasTooltip,
  className = '',
  style = {}
}) => {
  if (!data) return null;
  const finalData = calculatePercentages(data);
  return /*#__PURE__*/React.createElement("div", {
    className: `chart__pie-chart ${className}`,
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%',
      height
    },
    className: "pie"
  }, /*#__PURE__*/React.createElement(ResponsiveContainer, null, /*#__PURE__*/React.createElement(PieChart, null, /*#__PURE__*/React.createElement(Pie, {
    data: finalData,
    innerRadius: "62%",
    outerRadius: "80%",
    startAngle: 90,
    endAngle: -270,
    paddingAngle: 5,
    dataKey: "percentage",
    animationBegin: 0,
    animationDuration: 1000
  }, finalData.map((item, index) => /*#__PURE__*/React.createElement(Cell, {
    key: `cell-${index}`,
    fill: colors[index]
  }))), hasTooltip && /*#__PURE__*/React.createElement(RechartsTooltip, {
    content: /*#__PURE__*/React.createElement(Tooltip, null)
  })))), hasLegend && /*#__PURE__*/React.createElement(Legend, {
    data: finalData,
    colors: colors
  }));
};

DonutChart.defaultProps = {
  hasLegend: true,
  hasTooltip: true,
  height: '8rem',
  colors: chartColors
};
DonutChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired
  })).isRequired,
  hasLegend: PropTypes.bool,
  hasTooltip: PropTypes.bool,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  colors: PropTypes.array,
  className: PropTypes.string,
  style: PropTypes.object
};
export default DonutChart;